export default __webpack_public_path__ + "static/media/bg.72ae93a8.jpg";